// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {
	CurrencyType,
	DoorState,
	FridgeAccessSubscription,
	FridgeDishesSubscription,
	FridgeDoorSubscription,
	LockState,
	OrdersSubscription,
	Subscription,
	TransactionState,
} from "../../../../src/gql/graphql";
import { WSDataType } from "../types";

export interface SubscriptionData {
	id: string;
	type: string;
	payload: {
		data: Subscription;
	};
}

export const discountCodePinned = { total: "200.00", applied: "0.00" };
export const discountCodePartiallyUsed = { total: "200.00", applied: "159.00" };
export const discountCodeFullyUsed = { total: "200.00", applied: "200.00" };

export const appliedDiscountCode = (amount: { total: string; applied: string }) => ({
	code: "XMAS",
	name: "Vánoční bonus",
	amount: { ...amount, __typename: "AppliedDiscountCodeAmountSubscription" },
	__typename: "AppliedDiscountCodeSubscription",
});

export const emptyDataBase: SubscriptionData = {
	id: "1a393856-7d89-4779-b75b-d06466864d99",
	type: "data",
	payload: {
		data: {
			fridge: {
				id: "123e4567-e89b-12d3-a456-426614174000",
				access: null,
				dishes: {
					types: [
						{
							id: "f903f2b0-eac0-11ee-ba26-017635aabc68",
							dishes: [
								{
									id: "556baf7b-cdbe-4915-96ef-acce10336e0a",
									type: {
										id: "f903f2b0-eac0-11ee-ba26-017635aabc68",
										__typename: "DishTypeSubscription",
									},
									__typename: "DishSubscription",
								},
							],
						},
					],
				},
				door: {
					state: null,
					lock: {
						state: null,
						timeout: 20,
						__typename: "FridgeDoorLockSubscription",
					},
					__typename: "FridgeDoorSubscription",
				},
				lighting: {
					mode: null,
					__typename: "LightingSubscription",
				},
				transaction: {
					orders: null,
					refills: null,
					__typename: "FridgeTransactionSubscription",
				},
				segments: null,
				__typename: "FridgeSubscription",
			},
		},
	},
};

export const fridgeLastOrderActive: OrdersSubscription = {
	last: {
		id: "0d4ef945-f711-4275-9a1e-154c595f25fd",
		type: null,
		state: TransactionState.Active,
		user: {
			id: "874e7eeb-06bd-4eb5-8f3f-9e34b71ac205",
			name: "Playwright User",
			__typename: "UserSubscription",
		},
		inventory: {
			removed: [],
			added: null,
			updated: null,
			__typename: "TransactionInventorySubscription",
		},
		payment: null,
		price: {
			total: {
				default: "0",
				current: "0",
				currency: CurrencyType.Czk,
				__typename: "PriceSubscription",
			},
			__typename: "OrderPriceSubscription",
		},
		discountCode: appliedDiscountCode(discountCodePinned),
		__typename: "OrderSubscription",
	},
	__typename: "OrdersSubscription",
};

export const fridgeDoor = (type: WSDataType) => {
	const data: FridgeDoorSubscription = {
		state: null,
		lock: {
			state: null,
			timeout: 20,
			__typename: "FridgeDoorLockSubscription",
		},
		__typename: "FridgeDoorSubscription",
	};
	switch (type) {
		case WSDataType.DOOR_UNLOCKED:
			data.lock.state = LockState.Unlocked;
			break;
		case WSDataType.DOOR_LOCKED:
			data.lock.state = LockState.Locked;
			break;
		case WSDataType.DOOR_OPENED:
			data.state = DoorState.Opened;
			data.lock.state = LockState.Locked;
			break;
		case WSDataType.DOOR_CLOSED:
			data.state = DoorState.Closed;
			break;
	}

	return data;
};

export const fridgeAccess: FridgeAccessSubscription = {
	qrCode: {
		code: "data:image/png;base64,aaa=",
		__typename: "QrCodeSubscription",
	},
	__typename: "FridgeAccessSubscription",
};

export const fridgeRefillActive = {
	last: {
		id: "refill-e2e-001",
		type: null,
		state: TransactionState.Active,
		mode: "REMOTE",
		user: {
			id: "874e7eeb-06bd-4eb5-8f3f-9e34b71ac205",
			name: "Playwright User",
			__typename: "UserSubscription",
		},
		inventory: {
			removed: null,
			added: null,
			updated: null,
			__typename: "TransactionInventorySubscription",
		},
		__typename: "RefillSubscription",
	},
	__typename: "RefillsSubscription",
};

export const fridgeRefillFinished = {
	last: {
		...fridgeRefillActive.last,
		state: TransactionState.Finished,
	},
	__typename: "RefillsSubscription",
};

export const fridgeDishes: FridgeDishesSubscription = {
	types: [
		{
			id: "f903f2b0-eac0-11ee-ba26-017635aabc68",
			description: null,
			image: null,
			price: null,
			weight: null,
			allergens: null,
			lighting: {
				mode: null,
				__typename: "DishTypeLightingSubscription",
			},
			dishes: null,
			__typename: "DishTypeSubscription",
		},
	],
	__typename: "FridgeDishesSubscription",
};
